// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../styles/_colors.css\"","off-white":"#f4f6f9","dark-grey":"#475166","container":"Tags_container__3UJyr","tag":"Tags_tag__q5d7O"};